import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { View, StyleSheet } from 'react-native';
import R from '../../../core-res/R';
class Line extends PureComponent {
    render() {
        const { color: borderColor, type: borderStyle } = this.props;
        const lineStyle = {
            borderColor,
            borderStyle,
        };
        return <View style={[styles.line, lineStyle]} pointerEvents="none"/>;
    }
}
Line.propTypes = {
    type: PropTypes.oneOf(['solid', 'dotted', 'dashed']).isRequired,
    color: PropTypes.string.isRequired,
};
const styles = StyleSheet.create({
    container: {
        paddingVertical: R.spacing.xxs,
        paddingLeft: R.spacing.xxs,
    },
});
export default Line;
